import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);
	}

	init() {
		this.$wpcf7Form = this.el.querySelector(".wpcf7-form");

		function callback(mutationsList, observer) {
			mutationsList.forEach((mutation) => {
				if (mutation.attributeName === "data-status") {
					if (mutation.oldValue != "init" && mutation.oldValue != "validating" && mutation.oldValue != "resetting") {
						clearTimeout(this.timeout);
						mutation.target.querySelector(".wpcf7-response-output").classList.add("is-active");

						this.timeout = setTimeout(function () {
							mutation.target.querySelector(".wpcf7-response-output").classList.remove("is-active");
						}, 5000);

						if (mutation.target.className == "wpcf7-form submitting") {
							if (document.querySelector("html").lang == "fr") {
								mutation.target.querySelector(".wpcf7-response-output").textContent = "Envoi...";
							} else {
								mutation.target.querySelector(".wpcf7-response-output").textContent = "Sending...";
							}
						}
					}
				}
			});
		}

		const mutationObserver = new MutationObserver(callback);

		mutationObserver.observe(this.$wpcf7Form, { attributes: true, attributeOldValue: true });
	}

	destroy() {}
}
